import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'via-keyword-filter-bar',
    templateUrl: './keyword-filter-bar.component.html',
    styleUrls: ['./keyword-filter-bar.component.scss'],
})
export class KeywordFilterBarComponent {
    @Output()
    public searchFilters = new EventEmitter<string>();

    @Output()
    public clearSearch = new EventEmitter();

    @Input()
    public isDisabled: boolean;

    public keyword = '';
    public keywordFilterTooltip = 'Keyword filter tooltip text.';

    public filterByKeyword(): void {
        if (this.keyword.length > 1) {
            this.searchFilters.emit(this.keyword);
        }

        if (this.keyword.length === 0) {
            this.clearSearch.emit();
        }
    }

    public resetSearch(): void {
        this.keyword = '';
        this.clearSearch.emit();
    }
}
